<template>
  <div class="container letter__box">
    <div class="letter__header">
      <div class="d-flex align-items-stretch justify-content-center">
        <div class="d-flex align-items-center justify-content-center letter__th"
          style="width: 100px">
          <span>郵件名稱</span>
        </div>
        <div class="d-flex align-items-center letter__td flex-fill"
          style="min-width:300px; max-width: 300px">
          <input type="text" class="form-control flex-fill" placeholder="郵件名稱"
            v-model="letterList.title.inname">
        </div>
        <div class="d-flex align-items-center justify-content-center letter__th"
          style="width: 100px">
          <span>發送對象</span>
        </div>
        <div class="d-flex align-items-center letter__td flex-fill">
          <span>所有訂閱者（區間）／班務表／訂單（個人）</span>
        </div>
      </div>
      <div class="d-flex align-items-stretch justify-content-center">
        <div class="d-flex align-items-center justify-content-center letter__th"
          style="width: 100px">
          <span>Email主旨</span>
        </div>
        <div class="d-flex align-items-center letter__td flex-fill"
          style="min-width:300px; max-width: 300px">
          <input type="text" class="form-control flex-fill" placeholder="郵件主旨"
            v-model="letterList.title.title">
        </div>
        <div class="d-flex align-items-center justify-content-center letter__th"
          style="width: 100px">
          <span>發送日期</span>
        </div>
        <div class="d-flex align-items-center letter__td flex-fill">
          <input type="date" class="form-control flex-fill" v-model="letterList.title.sendTime">
          <b-form-checkbox class="ml-2 text-nowrap" v-model="letterList.title.sync">同時發布公告於網站
          </b-form-checkbox>
        </div>
      </div>
    </div>
    <!-- letter body -->
    <div class="letter__body d-flex">
      <div class="flex-fill" :class="letterList.title.style">
        <div class="d-flex align-items-center justify-content-center">
          <div
            class="d-flex align-items-center justify-content-center align-self-stretch ctrl__title border border-bottom-0">
            <span>頁首</span>
            {{letterList.body.length}}
          </div>
          <div
            class="flex-fill d-flex align-items-center justify-content-center mail__body border-top"
            :style="{'background-color': letterList.title.backColor}">
            <!-- <img :src="letterList.header.image" /> -->
            <div class="flex-fill">
              <div
                class="w-100 d-flex flex-column align-items-center justify-content-center mail__banner"
                :style="'background-image: url(' + letterList.header.image + ')'">
                <h1 v-if="letterList.header.title">{{letterList.header.title}}</h1>
                <p v-if="letterList.header.titleSub">{{letterList.header.titleSub}}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-center"
          v-for="(body, index) in letterList.body" :key="'letter__body__' + index">
          <div
            class="d-flex flex-column align-items-center justify-content-start align-self-stretch ctrl__title border border-bottom-0">
            <span class="mb-2">{{index + 1}}</span>
            <button class="btn btn-sm btn-info mb-2" @click="editClick(index)">編輯</button>

            <button class="btn btn-sm btn-primary mb-2"
              v-if="((index + 1) == letterList.body.length)" @click="createBody()">新增</button>
            <button class="btn btn-sm btn-danger mb-2" @click="deleteBody(body)">刪除</button>
          </div>
          <div
            class="flex-fill d-flex align-items-start align-self-stretch justify-content-center mail__body"
            :style="{'background-color': letterList.title.backColor}">
            <div class="w-100 h-100 mb-2">
              <component :is="getComponent(body.model)" :title="body.title"
                :titleSub="body.titleSub" :dataList="getDelete(body.dataList)">
              </component>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-center">
          <div
            class="d-flex align-items-center justify-content-center align-self-stretch ctrl__title border">
            <span>頁尾</span>
          </div>
          <div class="flex-fill mail__body border-bottom"
            :style="{'background-color': letterList.title.backColor}">
            <div class="w-100">
              <ul class="flex-fill d-flex align-items-start justify-content-around">
                <li v-for="(footer, index) in getDelete(letterList.footer.dataList)"
                  :key="'letter__footer__' + index">
                  <a :href="footer.buttonUrl">{{footer.buttonName}}</a>
                </li>
              </ul>
              <hr class="mx-4 mb-0">
              <div class="d-flex align-items-center justify-content-center py-4">
                <span>{{letterList.footer.title}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ctrl__box">
        <div class="w-100">
          <div class="mb-2 py-2 border-bottom bg-light">廣域設定</div>
          <div class="d-flex align-items-center border-bottom pb-2 mb-2">
            <span class="text-left" style="min-width: 100px">風格</span>

            <select class="form-control" v-model="letterList.title.style">
              <option value="mail__style__1">風格一</option>
              <option value="mail__style__2">風格二</option>
              <option value="mail__style__3">風格三</option>
            </select>

          </div>
          <div class="d-flex align-items-center border-bottom pb-2 mb-2">
            <span class="text-left" style="min-width: 100px">底色</span>
            <input type="color" class="form-control" v-model="letterList.title.backColor" />
          </div>
        </div>
        <!-- head -->
        <div class="w-100">
          <div class="mb-2 py-2 border-bottom bg-light">頁首設定</div>
          <div class="d-flex align-items-center border-bottom pb-2 mb-2">
            <span class="text-left" style="min-width: 100px">底圖</span>
            <input type="text" class="form-control flex-fill" v-model="letterList.header.image">
          </div>
          <div class="d-flex align-items-center border-bottom pb-2 mb-2">
            <span class="text-left" style="min-width: 100px">主名稱</span>
            <input type="text" class="form-control flex-fill" v-model="letterList.header.title">
          </div>
          <div class="d-flex align-items-center border-bottom pb-2 mb-2">
            <span class="text-left" style="min-width: 100px">次標題</span>
            <input type="text" class="form-control flex-fill" v-model="letterList.header.titleSub">
          </div>
        </div>
        <!-- body -->
        <div class="w-100">
          <div class="mb-2 py-2 border-bottom bg-light">內容設定</div>
          <div class="w-100" v-for="(body, index) in letterList.body"
            :key="'letter__body__ctrl__' + index">
            <div class="d-flex align-items-center border-bottom pb-2 mb-2">
              <span class="text-left" style="min-width: 100px">模組</span>
              <select class="form-control" v-model="body.model">
                <option value="">請選擇</option>
                <option :value="model.values" v-for="(model,index) in bodyModel"
                  :key="'body__model__'+index">{{model.name}}</option>
              </select>
            </div>
            <div class="d-flex align-items-center border-bottom pb-2 mb-2"
              v-if="checkModel(body.model) && body.model != ''">
              <span class="text-left" style="min-width: 100px">新增</span>
              <div class="d-flex align-items-center">
                <button class="btn btn-sm btn-primary mr-2" @click="createList(body.dataList)">
                  新增項目
                </button>
              </div>
            </div>
            <div class="w-100" v-if="body.model != ''">
              <div class="w-100" v-if="!checkModel(body.model) && (index == 0)"
                v-for="(data, index) in getDelete(body.dataList)">
                <div class="d-flex align-items-center mb-2"
                  v-for="(ctrl, key) in getField(body.model)">
                  <span class="text-left" style="min-width: 100px">{{ctrl.name}}</span>
                  <input :type="ctrl.type" class="form-control flex-fill"
                    v-model="data[ctrl.field]">
                </div>
              </div>

              <div class="w-100" v-if="checkModel(body.model)">
                <div class="w-100 d-flex flex-column align-items-center justify-content-center">
                  <div class="d-flex align-items-center mb-2">
                    <span class="text-left" style="min-width: 100px">主標題</span>
                    <input type="text" class="form-control flex-fill" v-model="body.title">
                  </div>
                  <div class="d-flex align-items-center mb-2" v-if="body.model == 'list'">
                    <span class="text-left" style="min-width: 100px">次標題</span>
                    <input type="text" class="form-control flex-fill" v-model="body.titleSub">
                  </div>
                </div>
                <b-tabs content-class="pt-2">
                  <b-tab :title="'第 '+ (index+1) +' 組'"
                    v-for="(data,index) in getDelete(body.dataList)">
                    <div class="d-flex align-items-start">
                      <button class="btn btn-sm btn-danger mb-2" @click="deleteList(data)">
                        刪除
                      </button>
                    </div>
                    <div class="d-flex align-items-center mb-2"
                      v-for="(ctrl, key) in getField(body.model)" :key="'ctrl__'+index+'__'+key">
                      <span class="text-left" style="min-width: 100px">{{ctrl.name}}</span>
                      <input :type="ctrl.type" class="form-control flex-fill"
                        v-model="data[ctrl.field]">
                    </div>
                  </b-tab>
                </b-tabs>
              </div>
            </div>
          </div>
        </div>
        <!-- footer -->
        <div class="w-100">
          <div class="mb-2 py-2 border-bottom bg-light">頁尾設定</div>
          <div class="d-flex align-items-center border-bottom pb-2 mb-2">
            <span class="text-left" style="min-width: 100px">公司名稱</span>
            <input type="text" class="form-control flex-fill" v-model="letterList.footer.title">
          </div>
          <div class="d-flex align-items-center border-bottom pb-2 mb-2">
            <span class="text-left" style="min-width: 100px">新增</span>
            <div class="d-flex align-items-center">
              <button class="btn btn-sm btn-primary mr-2"
                @click="createList(letterList.footer.dataList, 'footer')">
                新增項目
              </button>
            </div>
          </div>

          <b-tabs content-class="pt-2">
            <b-tab :title="'第 '+ (index+1) +' 組'"
              v-for="(data, index) in getDelete(letterList.footer.dataList)">
              <div class="d-flex align-items-start">
                <button class="btn btn-sm btn-danger mb-2" @click="deleteList(data)">
                  刪除
                </button>
              </div>
              <div class="d-flex align-items-center mb-2">
                <span class="text-left" style="min-width: 100px">名稱</span>
                <input type="test" class="form-control flex-fill" v-model="data.buttonName">
              </div>
              <div class="d-flex align-items-center mb-2">
                <span class="text-left" style="min-width: 100px">網址</span>
                <input type="test" class="form-control flex-fill" v-model="data.buttonUrl">
              </div>
            </b-tab>
          </b-tabs>

        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-end letter__footer">
      <button class="btn btn-sm btn-outline-primary ml-2" @click="previewLetter()">預覽</button>
      <button class="btn btn-sm btn-outline-success ml-2" @click="submitLetter()">儲存</button>
      <button class="btn btn-sm btn-outline-danger ml-2">刪除</button>
    </div>
  </div>
</template>

<script>
  import ctrl from '@/js/newsletter';
  export default ctrl;

</script>

<style lang="scss">
  .letter__box {
    height: 100%;

    .letter__header {
      margin-top: 1rem;

      .letter__th {
        white-space: nowrap;
        padding: 0.5rem;
        background-color: lightgrey;
      }

      .letter__td {
        white-space: nowrap;
        padding: 0.5rem;
      }
    }

    .letter__body {
      margin-top: 1rem;

      .ctrl__title {
        min-width: 100px;
        max-width: 100px;
      }

      .ctrl__box {
        min-width: 250px;
        max-width: 250px;
      }

      .mail__body {
        width: 100%;

        color: #696969;
        line-height: 1.5;
        letter-spacing: 1px;

        font-family: 'Microsoft JhengHei';

        >div {
          min-width: 467px;
          max-width: 660px;
          margin: 0 auto;
          background-color: white;
        }
      }
    }
  }

  .mail__style__1 {
    color: #696969;
    line-height: 1.5;
    letter-spacing: 1px;

    font-family: 'Microsoft JhengHei';

    .mail__banner {
      padding: 40px 10px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: 100% 25%;

      h1 {
        font-weight: bold;

        margin-top: 0;
        margin-bottom: 0.75rem;

        line-height: 1.2;
        color: black;
        font-size: 2rem;
        text-align: center;
        text-shadow: 0px 0px 5px black;
      }

      p {
        // margin: 0px;
        color: black;
        font-size: 1rem;
        text-align: center;
      }
    }

    h1 {
      font-weight: bold;
      margin-top: 0;
      margin-bottom: 0.75rem;
      line-height: 1.2;
      color: black;
      font-size: 2rem;
      text-align: center;
    }

    h2 {
      font-weight: bold;
      line-height: 1.2;
      color: black;
      font-size: 1.5rem;
    }

    p {
      color: black;
      text-align: left;
    }
  }

</style>
